import {connect} from 'react-redux';

import {DASHBOARD_SCREEN, TEAMS_SCREEN} from '/enum/screen.enum';
import {competencyById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {
  frontlineCoachesCount,
  gen0CoachesCount,
  myTeamsCount,
  newFrontlineCoachesCount,
  newGen0CoachesCount,
  newOrganizationCoachesCount,
  organizationCoachesCount,
} from '/redux/selector/metric.home.selector';
import {
  allFrontlineById,
  allGeneration0ById,
  allOrganizationById,
  myTeamsById,
  newFrontlineById,
  newGeneration0ById,
  newOrganizationById,
} from '/redux/selector/metric.teams.selector';
import {createStructuredScreenSelector, withProps} from '/util/selector.util';

import CoachesSection from './CoachesSection';

const withCoachUserId = withProps({coachId: userId});

const SELECTOR_MAP = {
  allFrontline: {
    [DASHBOARD_SCREEN]: frontlineCoachesCount,
    [TEAMS_SCREEN]: allFrontlineById,
  },
  allGen0: {
    [DASHBOARD_SCREEN]: gen0CoachesCount,
    [TEAMS_SCREEN]: allGeneration0ById,
  },
  allOrganization: {
    [DASHBOARD_SCREEN]: organizationCoachesCount,
    [TEAMS_SCREEN]: allOrganizationById,
  },
  newFrontline: {
    [DASHBOARD_SCREEN]: newFrontlineCoachesCount,
    [TEAMS_SCREEN]: newFrontlineById,
  },
  newGen0: {
    [DASHBOARD_SCREEN]: newGen0CoachesCount,
    [TEAMS_SCREEN]: newGeneration0ById,
  },
  newOrganization: {
    [DASHBOARD_SCREEN]: newOrganizationCoachesCount,
    [TEAMS_SCREEN]: newOrganizationById,
  },
  myTeams: {
    [DASHBOARD_SCREEN]: myTeamsCount,
    [TEAMS_SCREEN]: myTeamsById,
  },
};

export default connect(
  createStructuredScreenSelector({
    selectorMap: SELECTOR_MAP,
    defaultScreenName: TEAMS_SCREEN,
    otherSelectors: {currentUserCompetency: competencyById},
    effect: withCoachUserId,
  }),
)(CoachesSection);
